require("../export");

var Logger = require('./logger');

ya.music.Audio.Logger = Logger;
